import { ADMIN_ACCESS } from '@/entities/admin/lib/adminAccessCodes'
import { adminHasAnyAccessCode } from '@/features/admin/lib/adminHasAccessCode'

const ADMIN_FALLBACK_ROUTES = [
  { name: 'admin-orders', accessCodes: [ADMIN_ACCESS.ORDERS, ADMIN_ACCESS.ORDERS_DELIVERY_FEE] },
  { name: 'admin-users', accessCodes: [ADMIN_ACCESS.USERS] },
  { name: 'admin-products', accessCodes: [ADMIN_ACCESS.CATALOG, ADMIN_ACCESS.CATALOG_EDIT] },
  {
    name: 'admin-restaurants',
    accessCodes: [ADMIN_ACCESS.RESTAURANTS, ADMIN_ACCESS.RESTAURANTS_EDIT],
  },
  { name: 'admin-wallets', accessCodes: [ADMIN_ACCESS.LEDGER] },
  { name: 'admin-profile', accessCodes: null },
]

export function resolveAdminFallbackRouteName(accessCodes) {
  for (const route of ADMIN_FALLBACK_ROUTES) {
    if (!route.accessCodes || adminHasAnyAccessCode(accessCodes, route.accessCodes)) {
      return route.name
    }
  }
  return 'admin-profile'
}
